import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/logo-tracker.svg'
import _imports_1 from '@/assets/auth/notfound/notfound-error.svg'


const _hoisted_1 = { class: "page-auth" }
const _hoisted_2 = { class: "auth-container" }
const _hoisted_3 = { class: "auth-logo" }
const _hoisted_4 = ["alt"]
const _hoisted_5 = { class: "auth-title" }
const _hoisted_6 = { class: "auth-desc" }
const _hoisted_7 = { class: "auth-image" }
const _hoisted_8 = ["alt"]
const _hoisted_9 = {
  href: "https://www.tracker.com/",
  class: "auth-powered",
  target: "_blank"
}
const _hoisted_10 = ["alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: _ctx.$t('pages.layout.notfound.logo_alt')
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t('pages.layout.notfound.title')), 1),
      _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$t('pages.layout.notfound.text')), 1),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("img", {
          src: _imports_1,
          alt: _ctx.$t('pages.layout.notfound.image_alt')
        }, null, 8, _hoisted_8)
      ]),
      _createVNode(_component_router_link, {
        to: { name: 'home' },
        class: "button auth-button"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('pages.layout.notfound.button')), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("a", _hoisted_9, [
      _createTextVNode(_toDisplayString(_ctx.$t('pages.auth.login.powered_by')) + " ", 1),
      _createElementVNode("img", {
        src: _imports_0,
        alt: _ctx.$t('pages.auth.login.powered_by_alt')
      }, null, 8, _hoisted_10)
    ])
  ]))
}